import { render, staticRenderFns } from "./WHeaderContainer.vue?vue&type=template&id=453fef8f&scoped=true&"
import script from "./WHeaderContainer.vue?vue&type=script&lang=js&"
export * from "./WHeaderContainer.vue?vue&type=script&lang=js&"
import style0 from "./WHeaderContainer.vue?vue&type=style&index=0&id=453fef8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453fef8f",
  null
  
)

export default component.exports